import React from 'react';
import { DashboardContainer } from '../../components/ui/UtilsLayout';
import { iconsPath } from '../../utils/imagePath';

const Teams = () => {
  return (
    <DashboardContainer>
      <div className="h-full w-full flex flex-col md:flex-row gap-2 lg:gap-6">
        {/* Left Section: Teams List */}
        <div className="rounded-lg px-4 py-4 md:h-full w-full md:w-64 bg-[#1E1F22] flex flex-col gap-2">
          <h2 className="text-lg font-bold">Teams</h2>
          <p className="text-gray-400 text-sm">You currently have no teams</p>

          {/* Add Team Button */}
          <button className="flex items-center gap-3 bg-[#333334] p-2 rounded-md hover:bg-[#3d3d40] transition">
            <div className="w-10 h-10 bg-[#4C4C50] rounded-md flex items-center justify-center">
              <img
                className="h-4 w-4 object-cover"
                src={iconsPath?.group10Image}
                alt="Add teams"
                loading="lazy"
              />
            </div>
            <span className="text-base">Add a Team</span>
          </button>
        </div>

        {/* Right Section */}
        <div className="relative rounded-lg px-4 py-4 w-full bg-[#1E1F22] flex flex-col gap-2">
          {/* Search Bar (Top Right) */}
          <div className="absolute top-10 right-10">
            <div className="relative">
              <input
                type="text"
                placeholder="Search"
                className="bg-[#444447] text-sm text-gray-300 rounded-lg pl-9 pr-3 py-2 w-80 focus:outline-none border border-[#5C5C5C] placeholder:text-[#B8B8B8] "
              />
              <img
                src={iconsPath?.group98Image}
                alt="Search"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 opacity-70 text-[#B8B8B8]"
              />
            </div>
          </div>

          {/* Empty State */}
          <div className="h-full flex flex-col items-center justify-center text-center">
            <h2 className="text-xl font-bold">This Team has no projects yet</h2>
            <p className="text-gray-400 text-sm mt-1">
              Organize your team's files by creating your first project
            </p>
          </div>
        </div>
      </div>
    </DashboardContainer>
  );
};

export default Teams;
